export const calendarConstants = {
  // check calendar linked
  CHECK_GOOGLE_CALENDAR_LINKED_ACTION_REQUEST:
    "CHECK_GOOGLE_CALENDAR_LINKED_ACTION_REQUEST",
  CHECK_GOOGLE_CALENDAR_LINKED_ACTION_SUCCESS:
    "CHECK_GOOGLE_CALENDAR_LINKED_ACTION_SUCCESS",
  CHECK_GOOGLE_CALENDAR_LINKED_ACTION_FAILURE:
    "CHECK_GOOGLE_CALENDAR_LINKED_ACTION_FAILURE",

  // check calendar linked
  GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_REQUEST:
    "GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_REQUEST",
  GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_SUCCESS:
    "GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_SUCCESS",
  GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_FAILURE:
    "GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_FAILURE",

  // check calendar linked
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_REQUEST:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_REQUEST",
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_SUCCESS:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_SUCCESS",
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_FAILURE:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_FAILURE",

  // store calendar token
  STORE_GOOGLE_CALENDAR_TOKEN_ACTION_REQUEST:
    "STORE_GOOGLE_CALENDAR_TOKEN_ACTION_REQUEST",
  STORE_GOOGLE_CALENDAR_TOKEN_ACTION_SUCCESS:
    "STORE_GOOGLE_CALENDAR_TOKEN_ACTION_SUCCESS",
  STORE_GOOGLE_CALENDAR_TOKEN_ACTION_FAILURE:
    "STORE_GOOGLE_CALENDAR_TOKEN_ACTION_FAILURE",
};
